import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Popup = () => {
  const [isOpen, setIsOpen] = useState(true);

  const images = [
    "https://res.cloudinary.com/duxsqzrot/image/upload/v1770712063/WhatsApp_Image_2026-02-09_at_12.50.25_orre0u.jpg",
    // "https://res.cloudinary.com/dxvbzgdgw/image/upload/v1774244820/AIIFA_Flyer_page-0001_hfalwf.jpg",
  ];

  const data = [
    {
      img: "https://res.cloudinary.com/dxvbzgdgw/image/upload/v1775717738/postponement_of_Bharat_Steel_2026_1__page-0001_eggtco.jpg",
      link:'/bharat-steelexpo-2026'
    },
    // {
    //   img: "https://res.cloudinary.com/dxvbzgdgw/image/upload/v1779085874/New_Bharat_Buildcon_2026-IIFA_page-0001_jhkm5s.jpg",
    //   link:'/bharat-buildcon-2026'
    // }
  ]

  useEffect(() => {
    setIsOpen(true);
  }, []);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        
        {/* Close Button */}
        <button style={closeBtn} onClick={() => setIsOpen(false)}>
          ✕
        </button>

        {/* Swiper */}
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          autoplay={{
            delay: 2500, // 2.5 sec
            disableOnInteraction: false,
          }}
          loop={true}
        >
          {data.map((img, index) => (
            <SwiperSlide key={index}>
              <a href={img.link}>
                <img src={img.img} alt={`Slide ${index + 1}`} style={imgStyle} />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Popup;

// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const popupStyle = {
  width: "90%",
  maxWidth: "500px",
  background: "#fff",
  borderRadius: "10px",
  padding: "10px",
  position: "relative",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  borderRadius: "10px",
};

const closeBtn = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  cursor: "pointer",
  zIndex: 9999,
};